<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'uploadvideo',
})
</script>
<template>
  <a-upload
      v-model:file-list="fileList"
      :action="action"
      list-type="picture-card"
      :maxCount="1"
      accept=".mp4"
      :beforeUpload="beforeUpload"
      @change="change"
    >
      <div v-if="fileList.length==0">
        <plus-outlined />
        <div style="margin-top: 8px">上传图片</div>
      </div>
    </a-upload>
</template>
<script setup lang="ts" name="uploadvideo">
import { PlusOutlined } from '@ant-design/icons-vue'
import { ref,defineEmits,defineProps,watch,onMounted } from 'vue'
import { baseURL } from '@/utils/util'
import type { UploadProps } from 'ant-design-vue'
  const props=defineProps({
      value:{type:String}
  })
  const first=ref<boolean>(true)
  const action=ref<string>(baseURL+'/Upload/UploadVideo')
  const fileList=ref<UploadProps['fileList']>([])
  const emits= defineEmits(['update:value'])
  const change=(f:any)=>{
    fileList.value=f.fileList
    let url:String=''
    f.fileList.forEach(e => {
      if(e.response&&e.response.code==0){
        if(Array.isArray(e.response.data)){
            url=e.response.data[0].href
        }else{
            url=e.response.data.href
        }
        e.thumbUrl=baseURL+getJpgFromMp4(url)
      }
    })
    emits('update:value',url)
  }

  const getJpgFromMp4=(mp4:String)=>{
    if(mp4){
      return mp4.split('.')[0]+'.jpg'
    }else{
      return ''
    }
  }

  onMounted(()=>{
    if(props.value){
      if(typeof(props.value)=="string"){
        //视频截图在相同的路径下，且同名，拓展名为.jpg
        var list=[]
        var o:any={
          url:baseURL+props.value,
          thumbUrl:baseURL+getJpgFromMp4(props.value),
          status:'done',
          response:{code:0,data:{url:baseURL+props.value,href:props.value}}
        }
        list.push(o)
        fileList.value=list
      }
      }
  })

</script>
